import { QRCodeSVG } from 'qrcode.react';
import styled from 'styled-components';

import { useApply } from 'inquiry/lib/jsonLogic';
import { colorCss, sizeCss } from 'lib/inquiryStyles';
import { QrCodeComponent } from 'lib/interfaces/ui-components';
import { Inquiry } from 'verify/models/inquiry';

const StyledQrCode = styled(QRCodeSVG)<{ styles: QrCodeComponent['styles'] }>(({ styles }) => ({
  // Layout styles
  marginTop: sizeCss(styles?.margin.base.base?.top) ?? 0,
  marginBottom: sizeCss(styles?.margin.base.base?.bottom) ?? 0,
  marginLeft: sizeCss(styles?.margin.base.base?.left) ?? 0,
  marginRight: sizeCss(styles?.margin.base.base?.right) ?? 0,
  alignSelf: styles?.['justify'].base.base,
}));

interface QrCodeProp {
  component: QrCodeComponent;
  inquiry: Inquiry;
}

const QrCode = ({ component, inquiry }: QrCodeProp) => {
  const { value, hidden } = component.attributes;

  const apply = useApply(component.name, inquiry.attributes['next-step'].name);
  const isHidden = apply<boolean>(hidden);

  if (isHidden || !value) {
    return null;
  }

  return (
    <StyledQrCode
      data-test={component.type}
      value={value}
      height={undefined}
      width={sizeCss(component.styles?.width.base.base)}
      bgColor={colorCss(component.styles?.['fill-color'].base.base)}
      fgColor={colorCss(component.styles?.['stroke-color'].base.base)}
      styles={component.styles}
      // Needed for background color to "bleed" out a bit
      includeMargin
    />
  );
};

export default QrCode;
